import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import VariableInvoice from "./InvoiceList";
import {getValetContractInvoice} from "services/redux/sales/postSales/action";

const mapStateToProps = (state) => ({
    valetContractInvoice: state.postSalesReducer.valetContractInvoice,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getValetContractInvoice
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(VariableInvoice);
